var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-text-field__details"},[_c('div',{staticClass:"v-messages theme--light error--text",attrs:{"role":"alert"}},[_c('div',{staticClass:"v-messages__wrapper"},[_c('div',{staticClass:"v-messages__message"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }